import { Card, CardContent, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { LabelField } from 'components'
import { Chip } from 'components/chips'
import { MichiganOutgoingTitleDto } from 'dtos/michiganOutgoingTitles'
import { formatDateMoment } from 'utils'

interface MichiganOutgoingTitlesListCardProps {
  michiganOutgoingTitle: MichiganOutgoingTitleDto
}

export default function MichiganOutgoingTitleListCard({ children, michiganOutgoingTitle }: React.PropsWithChildren<MichiganOutgoingTitlesListCardProps>) {
  return (
    <Card>
      <CardContent>
        <Grid container direction='row' alignItems='flex-start' spacing={2}>
          <Grid item xs={12} md={4}>
            <Grid container spacing={2}>
              <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
                <Grid item xs={4}>
                  <Grid item>
                    <Chip variant={michiganOutgoingTitle.isLocked ? 'red' : 'green'}>{michiganOutgoingTitle.isLocked ? 'Locked' : 'Unlocked'}</Chip>
                  </Grid>
                </Grid>
                <Grid item xs={8} sm='auto'>
                  {children}
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <LabelField label='Count' value={michiganOutgoingTitle.vehicles?.length} />
              </Grid>

              <Grid item xs={12}>
                <LabelField
                  label='Tracking #'
                  value={michiganOutgoingTitle.fedExShipment?.trackingNumber}
                  onClick={
                    michiganOutgoingTitle.fedExShipment?.trackingNumber
                      ? () => window.open(`https://fedex.com/wtrk/track/?trknbr=${michiganOutgoingTitle.fedExShipment!.trackingNumber}`, '_blank')
                      : undefined
                  }
                />
              </Grid>

              <Grid item xs={12}>
                <LabelField
                  label='Group Shipped'
                  value={michiganOutgoingTitle.fedExShipment?.shipDateTime ? formatDateMoment(michiganOutgoingTitle.fedExShipment.shipDateTime) : undefined}
                />
              </Grid>

              <Grid item xs={12}>
                <LabelField
                  label='Group Delivered'
                  value={
                    michiganOutgoingTitle.fedExShipment?.deliveryDateTime ? formatDateMoment(michiganOutgoingTitle.fedExShipment.deliveryDateTime) : undefined
                  }
                />
              </Grid>

              <Grid item xs={12}>
                <LabelField
                  label='Created'
                  value={
                    michiganOutgoingTitle.createdDateTime
                      ? `${formatDateMoment(michiganOutgoingTitle.createdDateTime)} by ${
                          michiganOutgoingTitle.createdByPerson
                            ? `${michiganOutgoingTitle.createdByPerson.firstName} ${michiganOutgoingTitle.createdByPerson.lastName || ''}`.trim()
                            : '-'
                        }`
                      : '-'
                  }
                />
              </Grid>

              <Grid item xs={12}>
                <LabelField
                  label='Modified'
                  value={
                    michiganOutgoingTitle.updatedDateTime
                      ? `${formatDateMoment(michiganOutgoingTitle.updatedDateTime)} by ${
                          michiganOutgoingTitle.updatedByPerson
                            ? `${michiganOutgoingTitle.updatedByPerson.firstName} ${michiganOutgoingTitle.updatedByPerson.lastName || ''}`.trim()
                            : '-'
                        }`
                      : '-'
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} md={8} container alignItems='flex-start'>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Importer Stock#</TableCell>

                    <TableCell>VIN</TableCell>

                    <TableCell>Exporter</TableCell>

                    <TableCell>Buyer</TableCell>

                    <TableCell>Title Destination</TableCell>

                    <TableCell>Year</TableCell>

                    <TableCell>Make</TableCell>

                    <TableCell>Model</TableCell>

                    <TableCell>Title Uploaded</TableCell>

                    <TableCell>Signed BOL</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {michiganOutgoingTitle.vehicles?.map((vehicle, index) => (
                    <TableRow key={vehicle.vin} sx={{ backgroundColor: index % 2 === 0 ? '#FCFCFD' : 'white' }}>
                      <TableCell>{vehicle.importerStockNumber ?? '-'}</TableCell>

                      <TableCell>{vehicle.vin}</TableCell>

                      <TableCell>{vehicle.exporterCompany ?? '-'}</TableCell>

                      <TableCell>{vehicle.buyerCompany ?? '-'}</TableCell>

                      <TableCell>{vehicle.titleDestinationCompany ?? '-'}</TableCell>

                      <TableCell>{vehicle.year ?? '-'}</TableCell>

                      <TableCell>{vehicle.make ?? '-'}</TableCell>

                      <TableCell>{vehicle.model ?? '-'}</TableCell>

                      <TableCell>{vehicle.titleUploadedDateTime ? formatDateMoment(vehicle.titleUploadedDateTime) : '-'}</TableCell>

                      <TableCell>{vehicle.signedOutboundBOLUploadedDateTime ? formatDateMoment(vehicle.signedOutboundBOLUploadedDateTime) : '-'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
